export default __webpack_public_path__ + "static/404-9f82892d80bed38d60708e5846d47153.jpg";